// extracted by mini-css-extract-plugin
module.exports = {"page":"BY","account":"CY","pdp":"DY","cart":"EY","brand":"FY","cartModal":"GY","checkout":"HY"};